import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% {
        transform: rotate(0deg);
  }
  100% {
        transform: rotate(360deg);
  }
`;

export const Loader = styled.div`
    width: 40px;
    height: 40px;
    margin: 0 auto;
    border: 6px solid var(--color-grey-500); /* Light grey */
    border-top-color: var(--color-primary); /* Blue */
    border-left-color: var(--color-primary);
    border-radius: var(--radius-50);
    animation: ${spin} 2s linear infinite;
`;

export const LoaderWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const LoaderWrapperWithBorder = styled(LoaderWrapper)`
    height: 154px;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: var(--radius-10);
`;
